import React from 'react';
import classNames from 'classnames';

import { useEditorContext } from 'src/store/editor';

import { ShareSlideover } from 'src/common/components/share/slide-over';
import { EditorHeaderPreviewButton } from './preview-button';
import { EditorHeaderInsightsButton } from './insights-button';
import { EditorHeaderShareButton } from './share.button';
import { EditorHeaderAiAssistantButton } from './ai-assistant-button';

interface Props {
  headerBgClassname?: string;
}

export const EditorHeader = ({ headerBgClassname }: Props) => {
  // const { uuid } = useParams();
  const setJourney = useEditorContext((state) => state.setJourney);

  return (
    <div className={classNames('flex items-center', headerBgClassname || 'bg-bedrock-light-gray')}>
      <div className='ml-auto flex items-center justify-end space-x-sm'>
        <EditorHeaderAiAssistantButton />
        <EditorHeaderInsightsButton />
        <EditorHeaderPreviewButton />
        <EditorHeaderShareButton />
      </div>
      <ShareSlideover onUpdateJourney={setJourney} />
    </div>
  );
};
